import colors from '@settings/styleSettings'

export const tresholdValues = {
  imc: [25, 30],
  rcq: [0.9, 0.99],
  fat: [10, 20, 25],
  visceralFat: [9, 15],
  calories: [1600],
  muscleMass: [49.4, 59.5],
  triglycerides: [150, 200, 499],
  glucose: [100, 125],
  totalCholesterol: [190, 239],
  hdl: [40],
  ldl: [130, 160, 190],
  'hdl-c': [130],
  vldlCholesterol: [30, 40],
  bodyWater: [45, 60],
  protein: [15, 20],
  boneMass: [2, 4],
}

export const tresholdTypes = {
  imc: ['Normal', 'Sobrepeso', 'Obesidade'],
  rcq: ['Normal', 'Risco moderado', 'Alto risco'],
  fat: ['Baixo', 'Normal', 'Risco moderado', 'Alto risco'],
  visceralFat: ['Normal', 'Risco moderado', 'Alto risco'],
  calories: ['Baixo', 'Bom'],
  muscleMass: ['Baixo', 'Normal', 'Bom'],
  triglycerides: ['Normal', 'Limítrofe', 'Alto', 'Muito alto'],
  glucose: ['Normal', 'Alterada', 'Diabetes'],
  totalCholesterol: ['Normal', 'Limítrofe', 'Alterado'],
  hdl: ['Baixo', 'Normal'],
  ldl: ['Normal', 'Limítrofe', 'Alto', 'Muito alto'],
  bloodPressure: ['Ótima', 'Normal', 'Pré-hipertensão', 'Hipertensão'],
  'hdl-c': ['Normal', 'Alto'],
  vldlCholesterol: ['Normal', 'Alto'],
  bodyWater: ['Baixo', 'Normal', 'Bom'],
  protein: ['Baixo', 'Normal', 'Bom'],
  boneMass: ['Baixo', 'Normal', 'Bom'],
}

export const unitTypes = {
  imc: ' kg/m²',
  rcq: '',
  fat: '%',
  visceralFat: '',
  muscleMass: 'kg',
  calories: ' kcal',
  triglycerides: ' mg/dL',
  glucose: ' mg/dL',
  totalCholesterol: ' mg/dL',
  hdl: ' mg/dL',
  ldl: ' mg/dL',
  'hdl-c': ' mg/dL',
  vldlCholesterol: ' mg/dL',
  bodyWater: '%',
  protein: '%',
  boneMass: ' kg',
}

export const labelTypes = {
  imc: 'IMC',
  rcq: 'RCQ',
  fat: 'Gordura',
  visceralFat: 'Gordura Visceral',
  calories: 'Calorias',
  muscleMass: 'Massa magra',
  triglycerides: 'Triglicerídes',
  glucose: 'Glicemia',
  totalCholesterol: 'Colesterol total',
  hdl: 'Colesterol HDL',
  ldl: 'Colesterol LDL',
  'hdl-c': 'Não HDL-C',
  vldlCholesterol: 'Colesterol VLDL',
  bodyWater: 'Água Corporal',
  protein: 'Proteína',
  boneMass: 'Massa Óssea',
}

export const statusColors = {
  Baixo: colors.strongYellow,
  Normal: colors.strongGreen,
  Sobrepeso: colors.strongYellow,
  Obesidade: colors.strongRed,
  'Risco moderado': colors.strongYellow,
  Moderado: colors.strongYellow,
  'Alto risco': colors.strongRed,
  Alto: colors.strongRed,
  'Hipertensão Estágio 1': colors.strongYellow,
  'Hipertensão Estágio 2': colors.strongRed,
  Limítrofe: colors.strongYellow,
  'Pré-diabetes': colors.strongYellow,
  'Muito alto': colors.strongRed,
  Diabetes: colors.strongRed,
  Desejável: colors.strongGreen,
  Bom: colors.strongGreen,
  'Sem risco': colors.strongBlue,
  Alterado: colors.strongRed,
  Alterada: colors.strongYellow,
  noRisk: colors.strongBlue,
  lowRisk: colors.strongGreen,
  mediumRisk: colors.strongYellow,
  highRisk: colors.strongRed,
  Ótima: colors.strongGreen,
  'Pré-hipertensão': colors.strongYellow,
  Hipertensão: colors.strongRed,
  Estimado: colors.strongBlue,
  Referência: colors.strongGreen,
}

export const statusTypes = {
  noRisk: 'Sem risco',
  lowRisk: 'Baixo',
  mediumRisk: 'Moderado',
  highRisk: 'Alto',

  diabetic: 'Diabetes',
  amputation: 'Diabético com amputação',
  diabeticFoot: 'Pé diabético',
  nephropathy: 'Nefropatia',
  type2: 'Diabetes tipo 2',
  controlledGlycatedHemoglobin: 'Hemoglobina glicada controlada',
  diabeticFootEvaluated: 'Pé diabético avaliado',
  todayCollections: 'Hoje',
  lastWeekCollections: 'Última semana',
  lastMonthCollections: 'Último mês',
  lastSixMonthsCollections: 'Últimos 6 meses',
  male: 'Masculino',
  female: 'Feminino',
  collectionExpired: 'Coleta expirada',
  beneficiaryAge: 'Idade do beneficiário',

  alcohol: 'Consumo de álcool',
  smoking: 'Tabagismo',

  dyslipidemic: 'Dislipidemia',
  hypertensive: 'Hipertensão',
  controlledHypertension: 'Hipertensão controlada',

  overweight: 'Sobrepeso',
  overweightInRecovery: 'Sobrepeso em recuperação',

  orderByName: 'Ordenação por nome',
  orderByRisk: 'Ordenação por risco',

  activeAccounts: 'Contas ativas',
  frequentAccessApp: 'Acessos frequentes ao Saúde em Dia',
  diabeticsWithGlucometer: 'Diabéticos com glicosímetro',
  activeLoans: 'Empréstimos ativos',
  equipmentInUse: 'Equipamentos em uso'
}

export const statusFilter = {
  risk: 'Risco',
  diabetic: 'Diabetes',
  lifeHabits: 'Hábitos de vida',
  hypertensionAndDyslipidemia: 'Hipertensão e Dislipidemia',
  overweight: 'Sobrepeso',
  engagementBeneficiary: 'Engajamento do beneficiário',
  equipment: 'Equipamentos',
  todayCollections: 'Hoje',
  lastWeekCollections: 'Última semana',
  lastMonthCollections: 'Último mês',
  lastSixMonthsCollections: 'Últimos 6 meses',
  male: 'Masculino',
  female: 'Feminino',
  beneficiaryAge: 'Idade do beneficiário',
}

export const statusDescriptions = {
  diabetic: 'Prevalência de diabetes em beneﬁciários de programa (pessoas maiores de 18 anos com glicemia de jejum ≥ 126 mg/dl (7.0 mmol/l) OU histórico de diagnóstico de diabetes OU uso de insulina ou hipoglicêmico oral, participantes do programa)/total beneﬁciários da operadora maiores de 18 anos, com glicemia de jejum ≥ 126 mg/dl (7.0 mmol/l) OU histórico de diagnóstico de diabetes OU uso de insulina ou hipoglicêmico oral).',
  amputation: 'Prevalência de diabéticos beneﬁciários do programa com amputação de MMII.',
  diabeticFoot: 'Prevalência de beneﬁciários do programa com pé diabético.',
  nephropathy: 'Proporção de diabéticos beneﬁciários do programa com creatinina sérica e cálculo da taxa de ﬁltração glomerular para rastreamento da nefropatia diabética pelo menos uma vez no ano.',
  type2: 'Proporção de diabéticos tipo 2, beneﬁciários do programa, com pelo menos duas medidas de HbA1c por ano. ',
  controlledGlycatedHemoglobin: 'Proporção de diabéticos com a hemoglobina glicada controlada (menor ou igual que 5.7%) beneﬁciários do programa.',
  diabeticFootEvaluated: 'Proporção de diabéticos beneﬁciários do programa que tiveram avaliação dos pés realizada por enfermeiro/médico.',

  alcohol: 'Proporção de beneﬁciários do programa que consomem bebida alcoólica.',
  smoking: 'Proporção de beneﬁciários do programa que são tabagistas.',

  dyslipidemic: 'Proporção de beneficiários acima de 18 anos com dislipidemia.',
  hypertensive: 'Prevalência de hipertensos acima de 18 anos beneﬁciários do programa.',
  controlledHypertension: 'Proporção de hipertensos acima de 18 anos, beneﬁciários do programa, com níveis tensionais controlados.',

  overweight: 'Proporção de beneﬁciários do programa com excesso de peso  (IMC ≥ 25 kg/m2).',
  overweightInRecovery: 'Proporção de beneficiários do programa com excesso de peso (IMC ≥ 25 kg/m2) que perderam, pelo menos, 5% de peso após acompanhamento com a nutricionista.',

  noRisk: 'Beneficiários que não apresentam nenhuma comorbidade (Diabetes, Dislipidemia, Hipertensão ou Sobrepeso).',
  lowRisk: 'Beneficiários que apresentam 1 comorbidade (Diabetes, Dislipidemia, Hipertensão ou Sobrepeso).',
  mediumRisk: ' Beneficiários que apresentam até 2 comorbidades (Diabetes, Dislipidemia, Hipertensão ou Sobrepeso).',
  highRisk: 'Beneficiários que apresentam mais de 2 comorbidades (Diabetes, Dislipidemia, Hipertensão ou Sobrepeso).',

  activeAccounts: 'Proporção de beneficiários que realizaram o primeiro acesso no aplicativo Saúde em Dia e concluíram a criação de suas contas.',
  frequentAccessApp: 'Proporção de beneficiários que acessaram o aplicativo Saúde em Dia uma ou mais vezes durante o dia.',

  diabeticsWithGlucometer: 'Proporção de diabéticos, beneficiários do programa, que possuem o glicosímetro disponibilizado pela operadora de saúde',
  activeLoans: 'Proporção de beneficiários do programa que possuem empréstimos de equipamentos ativos.',
  equipmentInUse: 'Proporção de beneficiários que utilizaram um equipamento disponibilizado 1 ou mais vezes durante o dia.'
}
